export const demoZhCN = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': '即刻开玩 — 进入 Grymwyrd',
  'demo.seoDescription':
    '转动世界，在桌旁落座，锻造 Grymwyrd 英雄，骰子翻滚——Grymwyrd 虚拟桌面的导览体验。',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Grymwyrd 的世界',
  'demo.globe.spinningWorld': '世界转动中…',
  'demo.globe.tagline': '一个活生生的恐怖奇幻世界',
  'demo.globe.arrivedHeading': 'Greywick 地域',
  'demo.globe.heading': '在永恒的暮光中寻得你的归处',
  'demo.globe.subheading': '世界之心有一张桌子在等待。落座吧，锻造属于你的英雄。',
  'demo.globe.enterCta': '降临 Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': '成为故事的一部分',
  'demo.account.subheading':
    '创建免费账户解锁完整的 Grymwyrd 百科全书，并保存你即将锻造的英雄——或以客人身份通过，现在就探索。',
  'demo.account.createAccount': '创建账户',
  'demo.account.logIn': '登录',
  'demo.account.continueAsGuest': '以客人身份继续',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': '先攻',
  'demo.create.lobbyEyebrow': 'Grymwyrd 虚拟桌面 · 大厅',
  'demo.create.heading': '锻造你的英雄',
  'demo.create.subheading': '一个 SRD 5.2.1 角色，生于 Grymwyrd。为他们命名、选择职业，然后投掷骰子。',
  'demo.create.nameLabel': '名字',
  'demo.create.namePlaceholder': '他们将成为谁？',
  'demo.create.chooseCalling': '选择职业',
  'demo.create.keyAbility': '关键能力：{ability}',
  'demo.create.abilityScores': '能力值',
  'demo.create.abilityScoresHint': '——点击投掷 3d6',
  'demo.create.rollAbilityAria': '投掷 {ability} (3d6)',
  'demo.create.keepStandard': '或保持标准的 10 分，现在就开始。',
  'demo.create.initiativeResult': '先攻 {initiative} ——骰子翻滚，桌面转向你…',
  'demo.create.bonesTumble': '骰子翻滚…',
  'demo.create.rollInitiativeCta': '投掷先攻骰并落座',
  'demo.create.chooseCallingHint': '选择职业来落座。',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': '桌子未能布置',
  'demo.table.errorBody': '虚拟桌面暂时无法使用。',
  'demo.table.browseLiveTables': '改为浏览进行中的桌子',
  'demo.table.settingTable': '正在布置你的桌子…',
  'demo.table.connecting': '正在连接虚拟桌面…',
  'demo.table.heroTable': '{name} 的桌子',
  'demo.table.firstTable': '你的第一张桌子',
  'demo.table.diceTrayHeading': '骰子盘',
  'demo.table.initiativeHeading': '先攻',
  'demo.table.initiativePrompt': '投掷骰子来确定战斗顺序。',
  'demo.table.rollForInitiative': '投掷先攻',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': '暂停游戏，匿名进行',
  'demo.table.xcard': 'X 卡',
  'demo.table.saveHeroTitle': '创建免费账户来保存你的英雄',
  'demo.table.saveHero': '保存英雄',
  'demo.table.statusLive': '进行中',
  'demo.table.statusConnecting': '连接中',
  'demo.table.actionLogHeading': '行动日志',
  'demo.table.recentRollsHeading': '近期投掷',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': '英雄表',
  'demo.panel.companion': '伙伴设备',
  'demo.panel.diceTray': '骰子盘',
  'demo.panel.macros': '宏',
  'demo.panel.diceConsole': '骰子控制台',
  'demo.panel.initiative': '先攻',
  'demo.panel.poll': '投票',
  'demo.panel.recentRolls': '近期投掷',
  'demo.panel.reference': '参考',
  'demo.panel.chat': '聊天',
  'demo.panel.handouts': '讲义',
  'demo.panel.safety': '安全',
  'demo.panel.sceneAndCues': '场景与提示',
  'demo.panel.replay': '回放',
  'demo.panel.recap': '总结',
  'demo.panel.actionLog': '行动日志',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': '近战',
  'demo.action.cast': '施法',
  'demo.action.move': '移动',
  'demo.action.block': '防御',
  'demo.action.chooseTarget': '为 {action} 选择目标…',
  'demo.action.controlling': '控制中：',
  'demo.action.cannotAct': '{label} 无法行动——选择一个群体、玩家、载具或 NPC。',
  'demo.action.selectActionable': '选择一个可以行动的物体。',
  'demo.action.cancel': '取消',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': '正在确定顺序…',
  'demo.tracker.combatant': '战斗者 {n}',
  'demo.tracker.previousTurn': '上一轮合',
  'demo.tracker.round': '第 {round} 轮',
  'demo.tracker.endCombatTitle': '结束战斗',
  'demo.tracker.end': '结束',
  'demo.tracker.nextTurnTitle': '下一轮合',
  'demo.tracker.next': '下一步',
  'demo.tracker.hitPoints': '生命值',
  'demo.tracker.reduceHp': '减少 {name} 的生命值',
  'demo.tracker.raiseHp': '提高 {name} 的生命值',
  'demo.tracker.addStatusEffect': '添加状态效果',
  'demo.tracker.removeFromOrder': '移出顺序',
  'demo.tracker.removeFromOrderTitle': '从顺序中移出',
  'demo.tracker.removeCondition': '移除 {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': '桌子已暂停',
  'demo.xcard.heading': '桌子已暂停',
  'demo.xcard.body':
    '有人举起了 X 卡。我们暂停，毫无疑问，无人点名。当所有人准备好时，继续游戏。',
  'demo.xcard.resume': '我们准备好了——继续',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': '讲义',
  'demo.handouts.titlePlaceholder': '标题（可选）',
  'demo.handouts.bodyPlaceholder': '一条笔记、一条线索、一段读白…',
  'demo.handouts.push': '推送到桌子',
  'demo.handouts.whispered': '窃窃私语',
  'demo.handouts.dismiss': '关闭讲义',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': '安全',
  'demo.safety.description': '我们不会越过的底线；我们拉上的幕布。由整个桌子共享，永不归因。',
  'demo.safety.linesLabel': '底线（绝对禁止）',
  'demo.safety.veilsLabel': '幕布（淡出）',
  'demo.safety.removeItem': '移除"{item}"',
  'demo.safety.addLinePlaceholder': '添加底线…',
  'demo.safety.addVeilPlaceholder': '添加幕布…',
  'demo.safety.addLine': '添加底线',
  'demo.safety.addVeil': '添加幕布',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': '英雄表',
  'demo.sheet.hp': 'HP',
  'demo.sheet.ac': 'AC',
  'demo.sheet.classLevel': '{className} · 1 级',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': '伙伴设备',
  'demo.companion.description':
    '配对手机或平板电脑作为只读的第二屏幕——先攻、近期投掷和场景镜像到设备。随时可以撤销。',
  'demo.companion.pairDevice': '配对设备',
  'demo.companion.qrAriaLabel': '伙伴设备配对二维码',
  'demo.companion.copied': '已复制',
  'demo.companion.copyLink': '复制链接',
  'demo.companion.revoke': '撤销',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': '骰子宏',
  'demo.macros.dismissError': '关闭错误',
  'demo.macros.newMacro': '新建宏',
  'demo.macros.namePlaceholder': '名称（无点号）',
  'demo.macros.labelPlaceholder': '按钮标签（可选）',
  'demo.macros.save': '保存宏',
  'demo.macros.noDots': '宏名不能包含点号。',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': '投票',
  'demo.poll.questionPlaceholder': '向桌子提问…',
  'demo.poll.optionPlaceholder': '选项 {n}',
  'demo.poll.removeOption': '移除选项 {n}',
  'demo.poll.addOption': '添加选项',
  'demo.poll.openPoll': '开启投票',
  'demo.poll.live': '进行中',
  'demo.poll.closed': '投票已关闭',
  'demo.poll.vote': '投票',
  'demo.poll.closePoll': '关闭投票',
  'demo.poll.startNewPoll': '开启新投票',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': '场景总结',
  'demo.recap.tagline': '你的桌子的故事，当尘埃落定时。',
  'demo.recap.gathering': '正在汇集故事…',
  'demo.recap.getRecap': '获取场景总结',
  'demo.recap.notableRolls': '值得注意的投掷',
  'demo.recap.copied': '已复制！',
  'demo.recap.share': '分享',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': '参考',
  'demo.reference.searchPlaceholder': '查找怪物、法术、规则…',
  'demo.reference.searchAria': '搜索百科全书来分享',
  'demo.reference.typeToSearch': '至少输入两个字母来搜索活百科全书。',
  'demo.reference.searching': '正在搜索…',
  'demo.reference.open': '打开 {title}',
  'demo.reference.share': '分享',
  'demo.reference.dismiss': '关闭参考',
  'demo.reference.backToSearch': '返回搜索',
  'demo.reference.loadingContent': '正在加载内容…',
  'demo.reference.notOwned':
    '你还没有这本书。完整参考在你将其添加到库后解锁。',
  'demo.reference.contentDown': '内容暂时不可用。稍后再试。',
  'demo.reference.noAdditionalContent': '此参考没有额外内容。',
  'demo.reference.noLinkedContent': '此参考没有关联的书籍内容。',
  'demo.reference.shareToTable': '分享到桌子',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': '回放',
  'demo.replay.tagline': '一步步回顾整个场景。',
  'demo.replay.loading': '加载中…',
  'demo.replay.loadReplay': '加载回放',
  'demo.replay.loadMore': '加载更多',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': '骰子',
  'demo.dice.dismissError': '关闭错误',
  'demo.dice.labelPlaceholder': '攻击（可选）',
  'demo.dice.roll': '投掷',
  'demo.dice.rolledForReal': '我真的投了一下',
  'demo.dice.totalPlaceholder': '总数（必填）',
  'demo.dice.physNotationPlaceholder': '1d20+5（可选）',
  'demo.dice.physLabelPlaceholder': '标签（可选）',
  'demo.dice.logPhysical': '记录真实投掷',
  'demo.dice.onTable': '🎲 桌面上',
  'demo.dice.private': '私密',
  'demo.dice.public': '公开',
  'demo.dice.rolledPrivately': '私密投掷',
  'demo.dice.exploded': '爆裂',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': '场景与提示',
  'demo.scene.current': '场景：{scene}',
  'demo.scene.cueSuffix': '——提示：{cue}',
  'demo.scene.noScene': '未设置场景',
  'demo.scene.oneShotCues': '一次性提示',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} 位于 {x},{y}',
  'demo.map.tile': '瓷砖 {x},{y}',
  'demo.map.fogged': '迷雾中',
  'demo.map.battleMap': '战斗地图',
  'demo.map.gm': '地下城主',
  'demo.map.noMap': '无地图',
  'demo.map.uploadedMap': '上传的地图',
  'demo.map.uploadTitle': '上传地图图像作为画布背景',
  'demo.map.reading': '正在读取…',
  'demo.map.upload': '上传',
  'demo.map.size': '大小',
  'demo.map.shrinkMap': '缩小地图',
  'demo.map.growMap': '放大地图',
  'demo.map.widthShort': '宽',
  'demo.map.narrowMap': '地图变窄',
  'demo.map.widenMap': '地图变宽',
  'demo.map.heightShort': '高',
  'demo.map.shortenMap': '地图变矮',
  'demo.map.heightenMap': '地图变高',
  'demo.map.fitTitle': '重置位置 + 拉伸以填充网格',
  'demo.map.fit': '匹配',
  'demo.map.lock': '锁定',
  'demo.map.adjust': '调整',
  'demo.map.fogOn': '迷雾 开——点击禁用',
  'demo.map.fogOff': '迷雾 关——点击启用',
  'demo.map.fog': '迷雾',
  'demo.map.exitPaintTitle': '退出绘制模式',
  'demo.map.paintTitle': '绘制迷雾——点击或拖动格子来显示/隐藏',
  'demo.map.exitPaint': '退出绘制',
  'demo.map.paint': '绘制',
  'demo.map.hexGridTitle': '六边形网格——点击改为方形',
  'demo.map.squareGridTitle': '方形网格——点击改为六边形',
  'demo.map.hex': '六边形',
  'demo.map.zoomOut': '缩小',
  'demo.map.zoomLevel': '缩放级别',
  'demo.map.zoomIn': '放大',
  'demo.map.resetView': '重置视图',
  'demo.map.reset': '重置',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': '展开 {title}',
  'demo.dock.collapse': '折叠 {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': '离开桌子？',
  'demo.leave.heading': '离开桌子？',
  'demo.leave.body':
    '你正在进行游戏中。这是一张客人桌子——如果你现在离开，场景结束，你的英雄会丢失。',
  'demo.leave.stay': '留在桌子上',
  'demo.leave.leaveAnyway': '无论如何离开',
}
